import { ModalFormId } from 'src/components/ModalForms'

export enum GOOGLE_DRIVE_WIZARD_IMAGES {
  POLICIES_IMPORTER_1 = '../../images/gdrive-wizard/gdrive-policies-importer/gdrive-policies-importer-1.png',
}

export const GOOGLE_PICKER_SUPPORTED_FILE_TYPES =
  'application/vnd.google-apps.folder,image/png,image/jpeg,.rtf,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pages,.csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,.key,.numbers,application/vnd.google-apps.document,application/vnd.google-apps.spreadsheet,application/vnd.google-apps.presentation,application/pdf'

export type PickerConfiguration = {
  allowMultiselect: boolean
  viewId: google.picker.ViewId
  selectFolderEnabled?: boolean
  modalId: ModalFormId
  mimeTypes?: string
  selectableMimeTypes?: string
}

export type PickerResponse = {
  isShown: boolean
  invalidCredentials: boolean
  exceptions: string
}
